import api from '@/lib/api'

const state = () => ({
  settings_loaded: false,
  settings: {},
})

const getters = {
  settings: state => state.settings,
}

const actions = {
  async loadSettings( { state, commit } ) {
    // you only need to load settings once in an app
    if (state.settings_loaded)
      return { ok: true }

    const result = await api.get('/me/settings')
    if (result.ok) {
      commit('SET_SETTINGS', await result.json())
      return { ok: true }
    }
    
    return { ...await result.json(), status: result.status, ok: false }
  },
}

const mutations = { 
  SET_SETTINGS(state, settings) {
    state.settings = settings
    state.settings_loaded = true
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}